export const tableHeaderConfig: {
    id: string | number;
    name: string;
    isHidable: boolean;
    isSortable?: boolean;
    isSortableByBestMatch?: boolean;
    isSortableByDate?: boolean;
    sort?: { isSortableByBestMatch?: boolean; sortBy?: "date" | "a-z" };
    isHidden?: boolean;
    sx: React.CSSProperties;
}[] = [
    {
        id: "name",
        name: "User",
        isHidable: false,
        sort: { isSortableByBestMatch: false, sortBy: "a-z" },
        sx: { width: "26%" },
    },
    {
        id: "company",
        name: "User Company",
        isHidable: false,
        sx: { width: "28%" },
    },
    {
        id: "last_active_datetime",
        name: "Last Active",
        isHidable: false,
        sort: { isSortableByBestMatch: false, sortBy: "date" },
        sx: { width: "18%" },
    },
    {
        id: "hub",
        name: "Client Hub",
        isHidable: false,
        isSortable: false,
        sx: { width: "27%" },
    },
];

export const selectedUserstableHeaderConfig: {
    id: string | number;
    name: string;
    isHidable: boolean;
    isSortable?: boolean;
    isSortableByBestMatch?: boolean;
    isSortableByDate?: boolean;
    sort?: { isSortableByBestMatch?: boolean; sortBy?: "date" | "a-z" };
    isHidden?: boolean;
    sx: React.CSSProperties;
}[] = [
    {
        id: "name",
        name: "Selected Users",
        isHidable: false,
        isSortable: true,
        sort: { isSortableByBestMatch: false, sortBy: "a-z" },
        sx: { width: "100%" },
    },
];
